import { colors } from '../../constants';
import { SHADOW_LEVEL3 } from '../../shadows';
const MuiBadge = {
  badge: {
    boxShadow: SHADOW_LEVEL3,
    backgroundColor: colors.commonColors.white,
    border: `2px solid white`,
    height: 24,
    minWidth: 24,
    borderRadius: 12
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%'
  },
  colorPrimary: {
    boxShadow: 'none'
  },
  colorSecondary: {
    boxShadow: 'none'
  },
  colorError: {
    boxShadow: 'none'
  }
};
export default MuiBadge;